import React from 'react'
import { Col, Row } from 'reactstrap'
import { Breadcrumb } from '@shopline/dashboard-ui'
import appBridge from 'libs/appBridge'

function Layout({ children }) {
  return (
    <>
      <div id="layout-wrapper">{children}</div>
      <footer className="footer">
        <div className="container-fluid">
          <Row>
            <Col sm={6}>{new Date().getFullYear()}© Variant image App</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">Design & Develop by Shopline</div>
            </Col>
          </Row>
        </div>
      </footer>
    </>
  )
}

export default Layout
